<template>
  <div id="app">
    <div class="grid-item" id="inputs">
      <h2 class="bold">Input Investment Details</h2>
      <label class="text" for="initial_investment">Amount Invested:</label>
      <input class="number_input" name="initial_investment" v-model="invest" id="initial_investment" v-on:keyup="init"><br>

      <label class="text" for="hold_period">Years Held:</label>
      <input class="number_input" name="hold_period" id="hold_period" v-model.number="hold_period" v-on:keyup="initAndKey"><br>

      <label class="text" for="irr">IRR:</label>
      <input class="number_input" name="irr" id="irr" v-model="irr" v-on:keyup="init"><br>


      <span>Is there cash flow from operations?<br>
        <input type="radio" id="one" v-model="return_profile" :value="true">
        <label for="one">Yes</label>
        <input type="radio" id="two" v-on:change="resetCashFlow" v-model="return_profile" :value="false" selected>
        <label for="two">No</label></span>

      <div v-if="return_profile" id="return_hidden">
      
        <label for="cash_flow_year_start" id="cash_flow_year_start">When does operating cash flow begin?</label>
          <vue-slider v-model="cash_flow_year_start_slide.value" v-on:change="init" :min="1" :max="typeof hold_period !== 'number' || hold_period == 1 ? 2 : hold_period" :key="cash_flow_year_key" :tooltip="'always'" :tooltip-formatter="'Year {value}'"></vue-slider>

          <!--<input v-model="cash_flow_year_start" v-on:keyup="init"><br>-->


        <label for="cash_flow" id="cash_flow">What is the average annual cash-on-cash return?</label>

          <vue-slider v-model="cash_on_cash_flow_slide.value" v-bind="cash_on_cash_flow_slide" v-on:change="init" :tooltip="'always'" :tooltip-formatter="'{value}%'"></vue-slider>

          <!--<input v-model="cash_on_cash_flow_slide.value" v-on:keyup="init"><br>-->

      </div>
    </div>

    <div class="grid-item" id="calc">
      <div id="returns">
        <h2 class="bold">Returns</h2>
        <div class="row">
          <div class="left bold">
            Total Returns
          </div>
          <div class="right">
            <strong class="bold">${{numberWithCommas(roundNumber(scenario2_calc.reduce((a,b)=>(isNaN(a) ? 0 : a) + (isNaN(b) ? 0 : b),0),2).toFixed(2))}}</strong>
          </div>
        </div>
      </div>
      
      <div id="yearly_breakdown">
        <div class="row">
          <div class="left">
            Initial Investment
          </div>
          <div class="right negative">({{numberWithCommas(invest)}})</div>
        </div>
        <div class="row" v-for="(val, index) in scenario2_calc" :key="`val-${index}`">
          <div class="left">
            Year {{index+1}}
          </div>
          <div class="right">
            ${{numberWithCommas(val.toFixed(2))}}
          </div>
        </div>
      </div>

<div id="profit">
  <div class="row">
    <div class="left">
      Profit
    </div>
    <div class="right">
      <strong class="bold">${{numberWithCommas(roundNumber(scenario2_calc.reduce((a,b)=>(isNaN(a) ? 0 : a) + (isNaN(b) ? 0 : b),0) - cleanNumber(this.invest),2).toFixed(2))}}</strong>
    </div>
  </div>
</div>

<div id="equity_multiple">
  <div class="row">
    <div class="left">
      Equity Multiple
    </div>
    <div class="right">
      <strong class="bold">{{invest == '$0' ? 0 : roundNumber(scenario2_calc.reduce((a,b)=>(isNaN(a) ? 0 : a) + (isNaN(b) ? 0 : b),0) / cleanNumber(this.invest),3)}}x</strong>
    </div>
  </div>
</div>

<div id="description">

    <p>This investment will result in a total return of <strong class="bold">${{numberWithCommas(roundNumber(scenario2_calc.reduce((a,b)=>(isNaN(a) ? 0 : a) + (isNaN(b) ? 0 : b),0),2).toFixed(2))}}</strong>. This is a profit of <strong class="bold">${{numberWithCommas(roundNumber(scenario2_calc.reduce((a,b)=>(isNaN(a) ? 0 : a) + (isNaN(b) ? 0 : b),0) - cleanNumber(this.invest),2).toFixed(2))}}</strong> and an equity multiple of <strong class="bold">{{invest == '$0' ? 0 : roundNumber(scenario2_calc.reduce((a,b)=>(isNaN(a) ? 0 : a) + (isNaN(b) ? 0 : b),0) / cleanNumber(this.invest),3)}}x</strong>.</p>

</div>

    </div>
  </div>
</template>

<script>

import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'

export default {
  name: 'App',
  components: {

    VueSlider,
  },
  data() {
    return {
      cash_flow_year_key: 0,
      cash_flow_year_start_slide: {
        value: 2,
        min: 1,
        //max: null,
        format: {
          prefix: 'Year ',
          //suffix: '%',
          decimals: 0,
        }
      },
      cash_on_cash_flow_slide: {
        value: 0,
        min: 0,
        max: 15,
        format: {
          //prefix: '$',
          suffix: '%',
          decimals: 0,
        }
      },
      irr_slide: {
        value: 16,
        min: 5,
        max: 25,
        format: {
          //prefix: '$',
          suffix: '%',
          //decimals: 2,
        }
      },
      return_profile: false,
      invest: '$0',
      irr: '16%',
      hold_period: 5,
      cash_flow: 9,
      cash_flow_year_start: 2,
      scenario1_calc: [],
      scenario2_calc: [],
      scenario3_calc: [],
    }
  },
  methods: {
    init() {
      // this.scenario1()
      this.scenario2()
      // this.scenario3()
      //this.cash_flow_year_start_slide.max = this.hold_period;
      this.invest = '$'+this.numberWithCommas(this.cleanNumber(this.invest))
      this.irr = this.cleanNumber(this.irr)+'%'
    },
    initAndKey()
    {
      if(typeof this.hold_period == 'number') // this would be better as a drop down than a text input
      {
        this.hold_period = Number(this.cleanNumber(this.hold_period))

        this.forceRerender()
        this.scenario2()
      }
    },
    resetCashFlow() {
      this.cash_on_cash_flow_slide.value = 0
      this.init()
    },
    forceRerender() {
      this.cash_flow_year_key += 1;
    },
    fv(rate, nper, pmt, pv, type) {
      var pow = Math.pow(1 + rate, nper),
        fv;

      pv = pv || 0;
      type = type || 0;

      if (rate) {
        fv = (pmt * (1 + rate * type) * (1 - pow) / rate) - pv * pow;
      } else {
        fv = -1 * (pv + pmt * nper);
      }
      return fv;
    },
    cleanNumber(x) {
      // removes commas, dollar, percent, and negative sign
      return x.toString().replace(/\$|,|%|-/g, '')
    },
    numberWithCommas(x) {
      // returns a string with commas when needed
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    roundNumber(num, scale) {
      if(!("" + num).includes("e")) {
        return +(Math.round(num + "e+" + scale)  + "e-" + scale);
      } else {
        var arr = ("" + num).split("e");
        var sig = ""
        if(+arr[1] + scale > 0) {
          sig = "+";
        }
        return +(Math.round(+arr[0] + "e" + sig + (+arr[1] + scale)) + "e-" + scale);
      }
    }, /*
    scenario1() {
      this.scenario1_calc = []
      // every year has a 5% cash flow until payout in last year
      console.log('scenario 1')
      var subs = this.hold_period
      for (var i = 1; i < subs; i++) {
        console.log(this.invest * (this.cash_flow / 100))
        this.scenario1_calc.push(this.invest * (this.cash_flow / 100))
      }
      var fv = this.fv((this.irr / 100), this.hold_period, this.invest * (this.cash_flow / 100), -1 * this.invest) + (this.invest * (this.cash_flow / 100))
      fv = this.roundNumber(fv,2)
      this.scenario1_calc.push(fv)
      console.log(fv)
    }, */
    scenario2() { //TODO
      this.scenario2_calc = []
      //console.log('scenario 2')
      let final = 0;
      let year = this.hold_period

      var clean_invest = typeof this.invest == 'number' ? this.invest : this.cleanNumber(this.invest)
      var clean_irr = typeof this.irr == 'number' ? this.irr : this.cleanNumber(this.irr)
      
      // every year, after cash flow year start, there is a 5% cash flow until full payout in last year
      for (var i = 1; i < this.hold_period; i++) {
        if (i < this.cash_flow_year_start_slide.value) {
          //console.log('-')
          this.scenario2_calc.push(0)
        } else {
          let current = (clean_invest * (this.cash_on_cash_flow_slide.value / 100) * (Math.pow(1 + (clean_irr / 100), year-- - this.cash_flow_year_start_slide.value))); // i - 1; //irr_slide.value
          //console.log(this.invest + ' * ' + (this.cash_on_cash_flow_slide.value / 100) + ' * ' + '(Math.pow(' + 1 + ' + ' + (this.irr / 100) + ', ' + i + ' - ' +this.cash_flow_year_start_slide.value+ ' ))')
          final = final - current
          //console.log(i + ': ' + current + ', ' + final)
          //console.log(this.invest * (this.cash_on_cash_flow_slide.value / 100))
          this.scenario2_calc.push(clean_invest * (this.cash_on_cash_flow_slide.value / 100))
        }
      }
      
      var fv = clean_invest * Math.pow(1 + (clean_irr / 100), this.hold_period) + final// + (this.invest * this.cash_flow) // not sure if needed...
      fv = this.roundNumber(fv,2)
      this.scenario2_calc.push(fv)

    }, /*
    scenario3() {
      this.scenario3_calc = []
      console.log('scenario 3')
      
      for (var i = 1; i < this.hold_period; i++)
      {
        this.scenario3_calc.push('-')
      }

      var final = this.invest * Math.pow(1 + (this.irr / 100), this.hold_period)
      final = this.roundNumber(final, 2)
      console.log(final)
      this.scenario3_calc.push(final)
    } */
  },
  mounted() {
    this.init()
  },
  computed: {
    cssVars() {
      return {
        '--slider-connect-bg': '#F00',
        '--slider-tooltip-bg': '#00F'
      }
    }
  }
}
</script>

<style src="@vueform/slider/themes/default.css"></style>

<style>

#app {
  width: 100%;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  flex-wrap: wrap;
  max-width:800px;
  font-size:.95em;
}

input.number_input {
  width:40%;
  height:2em;
  font-size:1.1em;
}

label.text {
  display: inline-block;

  height:3em;
  text-align: right;
  margin-right:.5em;
  font-size:1em;
}

#inputs input {
  margin-right:10%;
}

#returns, #yearly_breakdown, #profit {
  border-bottom:1px solid #ddd;
  margin: 0 0 18px 2.2em;
  padding-bottom:12px;
}

#equity_multiple, #description {
  margin: 0 0 0 2.2em;
}

#return_hidden {
  padding:0 1em;
  text-align:center;
}

@media only screen and (min-width: 800px) {
  #app {

  }
  .grid-item {
    margin: 0px 0px 26px 0px;
    width: 50%;
  }
#inputs {
  text-align:right;
}

}

@media only screen and (max-width: 799px) {
  #app {

  }
  .grid-item {
    margin: 0px 0px 26px 0px;
    width: 100%;
  }
label.text {
  width:182px;
}
}

@media only screen and (max-width: 600px) {
  #app {

  }
  .grid-item {
    margin: 0px 0px 26px 0px;
    width: 100%;
  }
input.number_input {
  width:75%;
  height:2em;
  font-size:1.1em;
  margin: 0 0 1em;
}

label.text {
  display: inline-block;
  width: 79%;
  margin:0;
  height:1.1em;
  text-align: left;
  font-size:1em;
}

.text.last {
display:none;
}

#returns, #yearly_breakdown, #profit {
  border-bottom:1px solid #ddd;
  margin: 0 0 18px;
  padding-bottom:12px;
}

#equity_multiple, #description {
  margin: 0;
}

#return_hidden {
  padding:0;
}

#inputs input {
  margin-right:2%;
}


}

.slider-green, .vue-slider-process {
  --slider-connect-bg: #009456;
  --slider-tooltip-bg: #009456;
  --slider-handle-ring-color: #009456;
  background:#009456;
  margin-bottom:1.5em;
}

.vue-slider-dot-tooltip-inner {
  background-color:#009456;
  border-color:#009456;
}

.vue-slider-dot-tooltip-text {
  padding:1px 5px 1px 0;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 28px;
}


#app #calc p {
  margin-top:0;
  font-size:.95em;
}

#app h2 {
  display:block;
  width:90%;
  text-align:left;
  font-size:.85em;
}

#inputs h2, #returns h2 {
  text-align:left;
}

#inputs span {
  text-align:center;
  width:100%;
  display:block;
}

#inputs span label {
  margin: 0 20px 0 4px;
}

#inputs span input {
  margin:18px 0;
}

#description {
  text-align:left;
  padding:0 5% 0 0;
  margin-top:2em;
}

#return_hidden label {
  margin:1.3em 0 3.1em;
  display:block;
}
.negative {
  color:#f00;
}

#calc .row {
  display:flex;
  padding:10px 0;
}

#yearly_breakdown .row {
  padding:5px 5%;
}

.left, .right {
  flex:50%;
  text-align:left;
}

.bold {
  font-weight:700;
  font-size:1.1em;
  color:#000;
}

.last {
  margin-bottom:0;
  height: 1.2em !important;
}

.slider-tooltip {
  /*border-radius:100%;
  width:4em;
  height:4em;*/
}

</style>
